module.exports = __webpack_public_path__ + "a59c90c683e1c4dbdca7f62f8b19f1a5.pdf";